import React from "react";
import { Modal, Button } from "react-bootstrap";
const RefundModal = (props) => {
  return (
    <div className="container">
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Refund Policy
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h1>Refund Policy</h1>
          <p>
            Pay After Salary System Refund Policy Thanks for purchasing our
            products or subscribing to our services at
            https://payaftersalary.com/ operated by Pay After Salary
            System Limited. We offer a full money-back guarantee for all
            purchases made on our website. If you are not satisfied with the
            product that you have purchased from us, you can get your money back
            no questions asked. You are eligible for a full reimbursement within
            14 calendar days of your purchase. After the 14-day period you will
            no longer be eligible and won't be able to receive a refund. We
            encourage our customers to try the product (or service) in the first
            two weeks after their purchase to ensure it fits your needs. If you
            have any additional questions or would like to request a refund,
            feel free to contact us.
            <p>This document was last updated on August 8, 2024</p>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default RefundModal;
